







































































import { Vue, Component, Ref } from 'vue-property-decorator'
import { QInfiniteScroll } from 'quasar'
import store from 'src/assets/store'
import dateShort from 'src/assets/dateShort'
import messenger from 'src/assets/messenger'
import PersonAvatar from 'src/components/account/PersonAvatar.vue'
import { MessengerActivity } from 'src/graphql/types'

@Component({
  components: {
    PersonAvatar
  }
})
export default class Messenger extends Vue {
  dateShort = dateShort
  me = store.state.person
  loading = true
  messenger = messenger

  @Ref()
  readonly activitiesLoader!: QInfiniteScroll

  async activitiesLoad (index: number, done: (stop?: boolean) => void) {
    await this.messenger.activitiesLoad(done)
    this.loading = false
  }
}
